import { Grid, Typography, useTheme } from "@mui/material";
import CircleOption from "../../../../components/filterOption/CircleOption";
import ImgOption from "../../../../components/filterOption/SeverityOption";
import ClearFiltersButton from "../../../../components/filters/ClearFiltersButton";
import FilterMenu from "../../../../components/filters/FilterMenu";
import SearchFilter from "../../../../components/filters/SearchFilter";
import SearchInput from "../../../../components/filters/SearchInput";
import { tokens } from "../../../../theme";

const TrackingFilters = ({
  setAppliedFilters,
  appliedFilters,
  filterOption,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Grid container spacing={1} alignItems={"center"}>
      {/* Search Bar */}

      {/* Filters */}
      <Grid item xs={12}>
        {" "}
        <Grid container spacing={1} alignItems={"center"}>
          <Grid item>
            <SearchFilter
              filterName={"Project"}
              fieldName={"projects"}
              options={filterOption.projects.map((project) => {
                return {
                  name: project.key,
                  label: project.name,
                  displayName: project.name,
                };
              })}
              appliedFilters={appliedFilters}
              setAppliedFilters={setAppliedFilters}
              fullOptions={filterOption.projects}
            />
          </Grid>
          <Grid item>
            <FilterMenu
              filterName={"Priority"}
              fieldName={"priorities"}
              options={filterOption.priorities.map((priority) => {
                if (priority === "All") {
                  return {
                    label: (
                      <Typography variant="caption">All Options</Typography>
                    ),
                    name: priority,
                    displayName: priority,
                  };
                }

                return {
                  label: <ImgOption label={priority} type={"jira"} />,
                  name: priority,
                  displayName: priority,
                };
              })}
              appliedFilters={appliedFilters}
              setAppliedFilters={setAppliedFilters}
              fullOptions={filterOption.priorities}
            />
          </Grid>
          <Grid item>
            <FilterMenu
              filterName={"Status"}
              fieldName={"statuses"}
              options={filterOption.statuses.map((status) => {
                return {
                  label: status,
                  name: status,
                  displayName: status,
                };
              })}
              appliedFilters={appliedFilters}
              setAppliedFilters={setAppliedFilters}
              fullOptions={filterOption.statuses}
            />
          </Grid>
          <Grid item>
            <FilterMenu
              filterName={"Status Category"}
              fieldName={"statusCategories"}
              options={filterOption.statusCategories.map((statusCategory) => {
                if (statusCategory === "All") {
                  return {
                    label: (
                      <Typography variant="caption">All Options</Typography>
                    ),
                    name: statusCategory,
                    displayName: statusCategory,
                  };
                }
                return {
                  label: (
                    <CircleOption label={statusCategory} type={"jiraStatus"} />
                  ),
                  name: statusCategory,
                  displayName: statusCategory,
                };
              })}
              appliedFilters={appliedFilters}
              setAppliedFilters={setAppliedFilters}
              fullOptions={filterOption.statusCategories}
            />
          </Grid>
          <Grid item>
            <SearchFilter
              filterName={"Assignee"}
              fieldName={"assignee"}
              options={filterOption.assignee.map((assignee) => {
                if (!assignee)
                  return {
                    name: "",
                    label: "Unassigned",
                    displayName: "Unassigned",
                  };
                return {
                  name: assignee,
                  label: assignee,
                  displayName: assignee,
                };
              })}
              appliedFilters={appliedFilters}
              setAppliedFilters={setAppliedFilters}
              fullOptions={filterOption.assignee}
            />
          </Grid>
          <Grid item>
            <SearchFilter
              filterName={"Label"}
              fieldName={"labels"}
              options={filterOption.labels.map((label) => {
                return {
                  label: label,
                  name: label,
                  displayName: label,
                };
              })}
              appliedFilters={appliedFilters}
              setAppliedFilters={setAppliedFilters}
              fullOptions={filterOption.labels}
            />
          </Grid>
          <Grid item>
            <FilterMenu
              filterName={"Control Status"}
              fieldName={"controlStatus"}
              options={filterOption.controlStatus.map((status) => {
                if (status === "All") {
                  return {
                    label: (
                      <Typography variant="caption">All statuses</Typography>
                    ),
                    name: status,
                    displayName: status,
                  };
                }
                return {
                  label: <CircleOption label={status} type={"status"} />,
                  name: status,
                  displayName: status,
                };
              })}
              appliedFilters={appliedFilters}
              setAppliedFilters={setAppliedFilters}
              fullOptions={filterOption.controlStatus}
            />
          </Grid>
          <Grid item>
            <ClearFiltersButton
              appliedFilters={appliedFilters}
              setAppliedFilters={setAppliedFilters}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={3}>
        <SearchInput
          fieldName={"searchString"}
          appliedFilters={appliedFilters}
          setAppliedFilters={setAppliedFilters}
        />
      </Grid>
    </Grid>
  );
};

export default TrackingFilters;
